import api from "../lib/api";

export const createRetension = (payload: any) =>
  api.post("/api/retension/create-retension-period", payload);

export const getRetensionDays = () =>
  api.get("/api/retension/get-retension-period");
export const getAllCourtRoomsForController = async () => {
  return api.get("/api/retension/get-courtrooms-for-controller");
};

// Stream settings: create or upsert settings for a court room
export const createStreamSetting = (payload: {
  courtRoomId: string;
  delayInMinutes: number;
  links: { link: string; key: string }[];
}) => api.post("/api/retension/stream/settings", payload);

export const getAllStreamSettings = () =>
  api.get("/api/retension/stream/settings");

export const updateStreamSetting = (payload: {
  id: string;
  courtRoomId: string;
  delayInMinutes: number;
  links: { link: string; key: string }[];
}) => api.put("/api/retension/stream/settings", payload);

export const deleteStreamSetting = (id: string) =>
  api.delete(`/api/retension/stream/settings/${id}`);
